import { FunctionComponent } from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import { CreatorPetsOwner } from '../../../gql/types'
import {
  petLocalizedString,
  petLocalizedStringInverse,
} from '../../../utils/GqlStrings'
import { petsOwnerOptions } from '../../../utils/mappers'
import { MultiSelectWithExclusion } from '..'

interface IProps {
  name: string
  control: Control<any>
  errors?: FieldErrors<any>
  label?: string
  placeholder?: string
  required?: boolean
  menuPlacement?: 'auto' | 'bottom' | 'top'
  className?: string
}

const PetsSelector: FunctionComponent<IProps> = ({
  name,
  control,
  errors,
  label = 'Do you have pets?',
  placeholder = 'Select your pets...',
  required = false,
  menuPlacement = 'auto',
  className = '',
}) => {
  return (
    <MultiSelectWithExclusion
      name={name}
      control={control}
      errors={errors}
      label={label}
      placeholder={placeholder}
      required={required}
      menuPlacement={menuPlacement}
      className={className}
      options={petsOwnerOptions}
      localizedStringFn={petLocalizedString}
      localizedStringInverseFn={petLocalizedStringInverse}
      noneValue={CreatorPetsOwner.noPets}
    />
  )
}

export { PetsSelector }
